__turbopack_context__.v({
  "centerSection": "_4BXYja_centerSection",
  "logo": "_4BXYja_logo",
  "rightSection": "_4BXYja_rightSection",
  "root": "_4BXYja_root",
  "title": "_4BXYja_title",
});
